import { Component, Input, OnInit } from '@angular/core';
import { SharedModule } from '@shared/module/shared.module';
import { JalaliPipe, JalaliTimePipeWithoutSecoundPipe } from '@shared/pipes/jalali-pipe/jalali.pipe';

@Component({
  selector: 'jalali-date',
  templateUrl: './jalali-date.component.html',
  styleUrls: ['./jalali-date.component.scss'],
  imports: [
    SharedModule,
    JalaliPipe,
    JalaliTimePipeWithoutSecoundPipe
  ]
})
export class JalaliDateComponent implements OnInit {
  @Input() date!: string;
  @Input() isBookdetail?: boolean = false;
  @Input() isBookProgress?: boolean = false;
  @Input() isBookActivity?: boolean = false;

  nowMilliseconds!: number;

  objectMilliseconds!: number;
  objectMinutes!: number;
  objectHours!: number;
  objectDay!: number;
  objectYear!: number;

  isDay!: boolean;
  isHour!: boolean;
  isMinutes!: boolean;
  isMounth!: boolean;
  isYear!: boolean;
  objectMounth!: number;
  objectWeek!: number;
  isWeek!: boolean;


  constructor() { }

  ngOnInit(): void {
    const now = new Date();
    this.nowMilliseconds = now.getTime();

    const objectDate = new Date(Date.parse(this.date));
    this.objectMilliseconds = objectDate.getTime();

    const fff = this.nowMilliseconds - this.objectMilliseconds;
    this.objectMinutes = Math.floor((fff / 1000 / 60));
    this.objectHours = Math.floor(this.objectMinutes / 60);
    this.objectDay = Math.floor(this.objectHours / 24);
    this.objectWeek = Math.floor(this.objectDay / 7);
    this.objectMounth = Math.floor(this.objectDay / 30);
    this.objectYear = Math.floor(this.objectDay / 365);

    if (this.objectMinutes <= 59)
      this.isMinutes = true;
    if (this.objectMinutes > 60 && this.objectHours <= 24)
      this.isHour = true;
    if (this.objectHours >= 24)
      this.isDay = true;
    if (this.objectDay > 7)
      this.isWeek = true;
    if (this.objectDay > 30)
      this.isMounth = true;
    if (this.objectDay > 365)
      this.isYear = true;
  }

}
